import { type PaletteOptions } from '@mui/material/styles'
import { additional } from './dark-additional'
import { blue } from './dark-blue'
import { green } from './dark-green'
import { grey } from './dark-grey'
import { opacity } from './dark-opacity'
import { pure } from './dark-pure'

export const components: PaletteOptions['components'] = {
  avatar: {
    backgroundBlue: additional.vibrandBlue,
    border: grey[400],
  },
  backdrop: {
    fill: opacity.dark[600],
  },
  buttonLink: {
    hover: grey[600],
  },
  chip: {
    icon: opacity.dark[400],
    focus: grey[900],
    border: grey[400],
  },
  dataGrid: {
    zebraDark: grey[200],
    hover: 'rgba((255, 255, 255, 0.10)',
  },
  divider: {
    line: grey[300],
  },
  input: {
    background: pure.light,
  },
  navbar: {
    selected: opacity.primary[100],
    selectedHover: opacity.primary[150],
  },
  pageHeader: {
    default: grey[200],
    accept: green[200],
    test: blue[200],
    color: {
      contrast: pure.dark,
      default: pure.dark,
    },
  },
  switch: {
    fill: grey[300],
    hover: opacity.dark[50],
    focus: opacity.dark[80],
    border: grey[400],
    knobDisabled: grey[400],
  },
}
